import { translateFormatter } from '@manomano-internal/i18n/esm/placeholders';
export const discoverTheBrandStore = translateFormatter<{
  brandName: string;
}>("Discover the {brandName} store", undefined, undefined, "en");